import http from "./http.service";

class Currency {

    getAllCurrencies(){
        return http.get('/api/currencies');
    }
}

export default new Currency();